<script lang="ts">
	import Logo from '$lib/components/partials/Logo.svelte'
  import { page } from '$app/state';
	import { getUniverseInfo } from '$lib/js/helpers'
	import { storeHeroMenu, storeMobileMenu } from "$lib/js/stores";
  import { t } from 'svelte-i18n-lingui';
  import type { Universe } from '$lib/js/strapi/types';
	import { getContextScope } from '$lib/js/helpers/i18n'
  import { onNavigate } from '$app/navigation'

  interface Props {
    type?: string; // '' | menu | bixoto
  }

  let { type = '' }: Props = $props();

  let current = -1
  let universe_color = $state('#efeff0')

	const scope = getContextScope()

  function optionHovered(universe: Universe, index: number) {
    current = index
    universe_color = universe.color
  }

  function optionUnhovered() {
    current = -1
    universe_color = '#efeff0'
  }

  let universe_info = $derived(getUniverseInfo(
    page.data?.universes_menu?.universes,
    page.data?.category?.url_path?.split("/")[1]
  ))

  let universes = $derived(universe_info && type !== "menu" ? page.data.universes_menu.universes.filter(univ => univ.name !== universe_info.name) : page.data.universes_menu.universes)

  onNavigate(() => {
    $storeHeroMenu = ''
    $storeMobileMenu = false
  })
</script>


<div class="universes {type}" style="--univ: {universe_color};">
  <div class="universes__inner">
    {#if type === "bixoto"}
      <a class="universes__link bixoto" href="/{scope}" aria-label="{$t`Home`}"><Logo/></a>
    {/if}

    {#each universes as universe, index}
      <a
        href="/{scope}/u/{universe.name}"
        class="universes__link"
        onmouseenter={() => optionHovered(universe, index)}
        onmouseleave={() => optionUnhovered()}
      >
        <img class="bg-img" src="/images/bg-grey.jpg" alt="Universe Background" title="Universe Background"/>
        <div class="img-shadow"></div>
        <div class="universes__link__inner">
          <div class="universes__link__header">
            <img
              src="/images/universes/logos/{universe.name}.svg"
              alt={universe.name}
              title={universe.name}
              class="logo"
              height=30
              width=70
            />
            <img
              class="universes__link__img"
              src="/images/universes/main/main_{universe.name}.png"
              alt="Universe {universe.name} Products"
              title="Universe Products"
              height=75
              width=120
            />
          </div>

          <p class="desc">{universe.description}</p>
        </div>
      </a>
    {/each}
  </div>
</div>


<style lang="scss">
  .universes {
    margin-top: 25px;

    &__inner {
      display: flex;
      flex-wrap: wrap;
      margin: 20px -5px 0;
    }

    &__link {
      display: block;
      position: relative;
      margin: 0 5px 12px;
      width: calc(50% - 10px);
      background: var(--grey);
      height: 53px;

      @media (min-width: 600px) {
        width: calc(33.3% - 10px);
      }

      @media (min-width: 769px) {
        height: 73px;
      }

      @media (min-width: 1200px) {
        width: calc(25% - 10px);
      }

      @media (min-width: 1400px) {
        width: calc(20% - 10px);
      }

      &:hover {
        background: var(--univ);

        .universes__link__img {
          transform: scale(1);
        }

        img.logo {
          filter: none;
        }
      }

      &.bixoto {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--main--l);
      }

      .bg-img,
      .img-shadow {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        visibility: hidden;
        opacity: 0;
      }

      &__img {
        transition: all linear 0.125s;
        transform: scale(0.92);
      }

      .img-shadow {
        mix-blend-mode: color;
      }

      &__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        column-gap: 15px;
        margin-top: -22px;

        @media (min-width: 769px) {
          margin-top: -42px;
        }

        img.universes__link__img {
          object-fit: contain;
          width: 80px;
          height: auto;

          @media (min-width: 769px) {
            width: 120px;
          }
        }

        img.logo {
          margin-bottom: 6px;

          @media (min-width: 769px) {
            filter: grayscale(1);
          }

          @media (max-width: 768px) {
            width: 60px;
            margin-bottom: 2px;
          }
        }
      }

      &__inner {
        position: relative;
        padding: 15px 12px 10px;

        @media (min-width: 769px) {
          padding: 25px 25px 15px;
        }

        p {
          color: black;
        }

        .desc {
          display: none;
        }
      }
    }

    &.menu {
      .universes {
        &__link {
          width: calc(50% - 10px);

          &__inner {
            padding: 15px 12px 10px;
          }

          &__header {
            margin-top: -22px;

            img.logo {
              width: 60px;
              margin-bottom: 2px;
              filter: none;
            }

            img.universes__link__img {
              object-fit: contain;
              width: 80px;
            }
          }
        }
      }
    }
  }
</style>
